<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-05 10:57:24
 * @Description: 收费标准
 -->

<template>
  <div class="standard-for-charge-wrapper">
    <img src="https://files.jinr.com/jinr-index/img/standard-for-charge.png" alt="" srcset="" />
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.standard-for-charge-wrapper {
  // padding: 20px 0 0;
  img {
    width: 100%;
  }
}
</style>
